export const DEFAULT_PAGINATOR_TEMPLATE =
  'FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink';

export const DEFAULT_PAGE_REPORT_TEMPLATE = 'Showing {first} to {last} of {totalRecords} entries';
